const SHAPES = {
  CLEAR: 'clear',
  DEFAULT: 'default',
  LIGHT: 'light',
};

export default {
  name: 'WeibyInput',
  props: {
    dense: {
      default: false,
      type: Boolean,
    },
    inputClass: {
      default: 'w-full',
      type: String,
    },
    inputWrapperClass: {
      default: 'w-full',
      type: String,
    },
    label: {
      default: '',
      type: String,
    },
    labelClass: {
      default: '',
      type: String,
    },
    maxLength: Number,
    message: {
      default: '',
      type: String,
    },
    passwordReveal: {
      default: false,
      type: Boolean,
    },
    showCount: {
      default: false,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    showSuccess: {
      default: false,
      type: Boolean,
    },
    type: {
      default: 'text',
      type: String,
    },
    value: {
      default: '',
      type: [String, Number],
    },
    shape: {
      default: SHAPES.DEFAULT,
      type: String,
      validator: (val) => Object.values(SHAPES).includes(val),
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    currentType() {
      if (this.passwordReveal) {
        return this.show ? 'text' : 'password';
      }
      return this.type;
    },
    colorType() {
      if (this.shape === SHAPES.LIGHT) {
        return '';
      }

      if (this.showError) {
        return 'w-input__color--error';
      }

      if (this.showSuccess) {
        return 'w-input__color--success';
      }

      return 'w-input__color--default';
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      };
    },
    textCount() {
      return this.value?.length || 0;
    },
    variant() {
      switch (this.shape) {
        case SHAPES.CLEAR:
          return 'w-input__shape--clear';

        case SHAPES.LIGHT:
          return 'w-input__shape--light';

        default:
          return 'w-input__shape--default';
      }
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
};
